var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"liveops-whitepaper-page h-100"},[_c('v-container',[_c('blog-acf-blocks',{staticClass:"h-100"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }